// extracted by mini-css-extract-plugin
module.exports = {"wrap":"render-column-boolean_wrap__V4N3m"};